import { useState, useEffect, useMemo } from 'react';
import styled, { keyframes } from 'styled-components';
import Image from 'next/image';
import { Flex } from '@lemonade-hq/cdk';

const marqueeAnimation = keyframes`
  to {
    transform: translateX(-50%);
  }
`;

const MarqueeWrapper = styled.div`
  width: 100%;
  overflow: clip;
`;

const MarqueeTrack = styled(Flex)`
  animation: ${marqueeAnimation} 30s linear infinite;
`;

export interface Slide {
  name: string;
  src: string;
}

interface Props {
  slides: Slide[];
  height?: number;
}

export const ImageSlider = ({ slides, height = 50 }: Props) => {
  const [repeatCount, setRepeatCount] = useState(1);

  const trackWidth = useMemo(() => slides.length * (50 + 48), [slides]);

  useEffect(() => {
    if (window != null) {
      const viewportWidth = window.innerWidth;
      const calculatedRepeatCount = Math.ceil(viewportWidth / trackWidth) + 1;

      setRepeatCount(calculatedRepeatCount);
    }
  }, [trackWidth]);

  const duplicatedSlides = useMemo(() => Array(repeatCount).fill(slides).flat(), [repeatCount, slides]);

  return (
    <MarqueeWrapper>
      <MarqueeTrack gap="48px" alignItems="center" width="max-content" height={height} pl="48px">
        {duplicatedSlides.map((slide, idx) => (
          <Image
            key={`${slide.name}-${idx}`}
            src={slide.src}
            alt={slide.name}
            // aria-hidden is set to true for all duplicated slides beyond the first set
            aria-hidden={idx >= slides.length ? true : undefined}
          />
        ))}
      </MarqueeTrack>
    </MarqueeWrapper>
  );
};
